// extracted by mini-css-extract-plugin
export default {"dividerLine":"DividerLine_dividerLine__Q7ZAE"};